import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ConfirmationService } from 'primeng/api';
import { DocumentTypeELynkPacketChecklistMode } from 'src/app/models/document';
import { ActionService } from 'src/app/services/actions/action.service';
import { AlertService, MessageSeverity } from 'src/app/services/alert.service';
import { ConfigurationService } from 'src/app/services/configuration/configuration.service';
import { DeleteElynkChecklistRequest, DeleteElynkChecklistResponse, SaveElynkChecklistRequest, SaveElynkChecklistResponse } from 'src/app/services/document-type/document-type-plugin-models';
import { ELynkPacket, ELynkPacketChecklist } from 'src/app/services/document-type/document-type.model';
import { DocumentTypeBaseComponent } from '../../document-types-base.component';

@Component({
    selector: 'app-elynk-packet-checklist',
    templateUrl: './elynk-packet-checklist.component.html',
    styleUrls: ['./elynk-packet-checklist.component.scss']
})
export class ElynkPacketChecklistComponent extends DocumentTypeBaseComponent implements OnChanges {
    constructor(
        private alertService: AlertService,
        private confirmationService: ConfirmationService,
        public actionService: ActionService,
        public configurationService: ConfigurationService

    ) {
        super(configurationService, actionService);
    }
    checklistModes = DocumentTypeELynkPacketChecklistMode;

    initialSelectedPacket: ELynkPacket = JSON.parse(JSON.stringify(this.newPacket));

    @Input() documentTypeId: number;
    @Input() selectedPacket: ELynkPacket = this.newPacket;

    @Output() selectedPacketChange = new EventEmitter<ELynkPacket>();

    @ViewChild('packetChecklistForm', { static: false }) packetChecklistForm: NgForm;

    ngOnChanges(changes: SimpleChanges): void {
        setTimeout(() => {
            this.selectedPacket.checklist ??= new ELynkPacketChecklist();
            this.setInitialPacket();
        });
    }

    async saveChanges() {
        try {
            const saveResponse = await this.savePacketChecklist(this.documentTypeId, this.selectedPacket);

            if (saveResponse.statusCode === 200) {
                this.selectedPacketChange.emit(this.selectedPacket);
                this.setInitialPacket();
                this.packetChecklistForm.form.markAsPristine();

                this.alertService.showMessage('Packet "checklist" settings saved.', null, MessageSeverity.success);
            } else {
                this.alertService.showMessage('Failed to save packet "checklist" settings.', 'Unknown error ocurred during saving of checklist.', MessageSeverity.error);
            }

        } catch (error) {
            this.alertService.showMessage('Failed to save packet "checklist" settings.', error.error.Message, MessageSeverity.error);
        }
    }

    resetForm() {
        this.packetChecklistForm.resetForm({
            categoryId: this.initialSelectedPacket.checklist.categoryId,
            mode: this.initialSelectedPacket.checklist.mode,
            editable: this.initialSelectedPacket.checklist.editable

        });
    }

    clearForm() {
        this.packetChecklistForm.resetForm({
            categoryId: "",
            mode: null,
            editable: null
        });
    }

    async deleteChecklist() {

        const msg = `Are you sure you want to delete ${this.selectedPacket.id} checklist configuration?`;

        this.confirmationService.confirm({
            key: 'ElynkChecklistDeleteDialog',
            message: msg,
            accept: async () => {

                try {
                    const deleteResponse = await this.deletePacketChecklist(this.documentTypeId, this.selectedPacket.id);

                    if (deleteResponse.statusCode === 200) {
                        this.clearForm();
                        this.selectedPacket.checklist = null;
                        this.alertService.showMessage('Checklist configuration deleted', null, MessageSeverity.success);
                    } else {
                        this.alertService.showMessage(`Failed to delete checklist configuration`, 'Unknown error ocurred during the deletion of checklist.', MessageSeverity.error);
                    }

                } catch (error) {
                    this.alertService.showMessage(`Failed to delete checklist configuration`, error.error.Message, MessageSeverity.error);
                }

            },
            reject: () => {
                return;
            }
        });
    }

    private setInitialPacket() {
        this.initialSelectedPacket = JSON.parse(JSON.stringify(this.selectedPacket));
    }

    private async savePacketChecklist(documentTypeId: number, packet: ELynkPacket): Promise<SaveElynkChecklistResponse> {
        const request = new SaveElynkChecklistRequest(documentTypeId, packet.id, packet.checklist);
        let response = await this.actionService.invoke(this.ActionType, "elynk-checklist-add", request) as SaveElynkChecklistResponse;
        return response;
    }

    private async deletePacketChecklist(documentTypeId: number, packetId: string): Promise<DeleteElynkChecklistResponse> {
        const request = new DeleteElynkChecklistRequest(documentTypeId, packetId);
        let response = await this.actionService.invoke(this.ActionType, "elynk-checklist-delete", request) as DeleteElynkChecklistResponse;
        return response;
    }
}
